import React, { useState, useEffect } from "react";

//material mui components
import { Box } from '@mui/material';

//config
import CodigosRegistrosGenericos from "../../../Configuracion/Llaves/CodigosRegistrosGenericos";
import { enlistaArrayCodigosMensajesIdiomas } from "../../../Actions/Generales/IdiomasAction";
import { MostrarMensaje } from "../../../Utilidades/ManejoMensajes";

//hooks
import { useGlobalState } from '../../../Utilidades/useGlobalState';

//components
import { TitleComponent } from '../Mobile/components/TitleComponent';
import { StepperMobile } from '../Mobile/components/StepperMobile';


//components
import HomeFooter from "../Home/HomeFooter";
import Registro from "../Registro";
import Admision from "../Admision";

//actions
import {
  listadoCamposDinamicosPortal,
  gestionCamposDinamicosPortal,
} from "../../../Actions/Utilidades/CamposDinamicosAction";

import {
  obtenerCifProspecto,
  obtenerListadoIdentificadores,
  obtenerListadoGeneros,
  obtenerListadoEstadosCiviles,
  obtenerTiposGenerios,
  obtenerListadoPaises,
} from "../RegistroUtiles";

//activos
import LogoClassLimitless from '../../../Activos/Icons/LogoClassLimitless';

export const LayoutMobile = ({  }) => {

  const { etiquetas, codigoIdioma, compania , dispatch} = useGlobalState();
  const [estadoRegistro, setEstadoRegistro] = useState(true);
  const [codigoVerificado, setCodigoVerificado] = useState(false);
  const [admisionPreExistente, setAdmisionPreExistente] = useState(false);
  const [activarBotones, setActivarBotones] = useState(true);
  const [idTipoCif, setIdTipoCif] = useState(
    "00000000-0000-0000-0000-000000000000"
  ); // se encarga del recolectar el identificador del tipo de Cif Prospecto (S)
  const [listIdentificadores, setListIdentificadores] = useState([]); // se encarga del recolectar el listado de identificadores
  const [listGeneros, setListGeneros] = useState([]); // se encarga del recolectar el listado de generos
  const [listEstadosCivil, setListEstadosCivil] = useState([]); // se encarga del recolectar el listado de estados civiles
  const [admisionEstudiante, setAdmisionEstudiante] = useState(
    "00000000-0000-0000-0000-000000000000"
  );
  const [requisitosPendientes, setRequisitosPendientes] = useState(0);
  const [camposDinamicosCRUD, setCamposDinamicosCRUD] = useState(false);
  const [listCamposRequeridos, setListCamposRequeridos] = useState([
    {
      code: "",
      codeError: "",
    },
  ]); // se encarga del recolectar el listado de campos requeridos
  //variable de estado local para las propiedades del componente
  const [Cliente, setCliente] = useState({
    cusCustomerId: "00000000-0000-0000-0000-000000000000",
    cusIde: "",
    cusTypeIdeFk: "",
    cusOtherIde: "",
    cusName: "",
    cusLastName1: "",
    cusLastName2: "",
    cusDateBirth: new Date(),
    cusGenderFk: "",
    cusStatus: true,
    cusCivilStatusFk: "",
    cusMail: "",
  });
  //variable de estado local para las propiedades del componente
  const [Credenciales, setCredenciales] = useState({
    companyId: "00000000-0000-0000-0000-000000000000",
    customerCIF: "",
    customerId: "00000000-0000-0000-0000-000000000000",
    defaultLanguage: "ES",
    email: "",
    imagen: null,
    imagenPerfil: null,
    nombreCompleto: "",
    state: true,
    token: "",
    userId: "00000000-0000-0000-0000-000000000000",
    username: "",
  });

  const [TipoTelefono, SetTipoTelefono] = React.useState({
    id: "00000000-0000-0000-0000-000000000000",
    description: "",
  }); // se encarga del recolectar el tipo de telefono

  const [ListTiposTelefonos, SetListTiposTelefonos] = useState([]); // se encarga del recolectar el listado de tipos de telefonos

  const [TipoCorreo, SetTipoCorreo] = React.useState({
    id: "00000000-0000-0000-0000-000000000000",
    description: "",
  }); // se encarga del recolectar el tipo de correo

  const [ListTiposCorreos, SetListTiposCorreos] = useState([]); // se encarga del recolectar el listado de tipos de correo

  const [TipoDireccion, SetTipoDireccion] = React.useState({
    id: "00000000-0000-0000-0000-000000000000",
    description: "",
  }); // se encarga del recolectar el tipo de direcci�n

  const [ListTiposDirecciones, SetListTiposDirecciones] = useState([]); // se encarga del recolectar el listado de tipos de direcciones

  const [PaisCIF, SetPaisCIF] = React.useState({
    couCountryId: "00000000-0000-0000-0000-000000000000",
    couName: "",
  }); // se encarga del recolectar el pais

  const [listPaises, setListPaises] = useState([]); // se encarga del recolectar el listado de paises


  useEffect(() => {

    LoadClientsProperties();

  }, [compania.ComCompanyId, codigoIdioma]);

  const funcionInicializarCombos = async (idcompaniaTemp) => {

    await obtenerCifProspecto(setIdTipoCif, dispatch);
    await obtenerListadoIdentificadores(
      idcompaniaTemp,
      setListIdentificadores,
      setCliente,
      dispatch
    );
    await obtenerListadoGeneros(
      idcompaniaTemp,
      setListGeneros,
      setCliente,
      dispatch
    );
    await obtenerListadoEstadosCiviles(
      idcompaniaTemp,
      setListEstadosCivil,
      setCliente,
      dispatch
    );
  };

  const LoadClientsProperties = async () => {
    if (
      compania.ComCompanyId === "" ||
      compania.ComCompanyId === undefined ||
      compania.ComCompanyId === null
    )
      return;
    else {
      dispatch({
        type: "LOAD_HOME",
        texto: etiquetas.CargandoModal.Et_Procesando,
      });

      funcionInicializarCombos(compania.ComCompanyId);

      dispatch({ type: "CLOSE_LOAD_HOME" });
    }
  };

  const LoadClientsContactProperties = async () => {
    dispatch({
      type: "LOAD_HOME",
      texto: etiquetas.CargandoModal.Et_Procesando,
    });
    const listContactosTemp = await obtenerTiposGenerios(
      CodigosRegistrosGenericos.TiposContactos,
      Credenciales,
      SetListTiposTelefonos,
      dispatch
    );
    SetTipoTelefono(
      listContactosTemp.length > 0
        ? {
            id: listContactosTemp[0].id,
            description: listContactosTemp[0].description,
          }
        : { id: "00000000-0000-0000-0000-000000000000", description: "" }
    );
    const listCorreosTemp = await obtenerTiposGenerios(
      CodigosRegistrosGenericos.TiposEmail,
      Credenciales,
      SetListTiposCorreos,
      dispatch
    );
    SetTipoCorreo(
      listCorreosTemp.length > 0
        ? {
            id: listCorreosTemp[0].id,
            description: listCorreosTemp[0].description,
          }
        : { id: "00000000-0000-0000-0000-000000000000", description: "" }
    );
    const listDireccionesTemp = await obtenerTiposGenerios(
      CodigosRegistrosGenericos.TiposDirecciones,
      Credenciales,
      SetListTiposDirecciones,
      dispatch
    );
    SetTipoDireccion(
      listDireccionesTemp.length > 0
        ? {
            id: listDireccionesTemp[0].id,
            description: listDireccionesTemp[0].description,
          }
        : { id: "00000000-0000-0000-0000-000000000000", description: "" }
    );
    const listPaisesTemp = await obtenerListadoPaises(setListPaises, dispatch);
    SetPaisCIF(
      listPaisesTemp.length > 0
        ? {
            couCountryId: listPaisesTemp[0].couCountryId,
            couName: listPaisesTemp[0].couName,
          }
        : { couCountryId: "00000000-0000-0000-0000-000000000000", couName: "" }
    );
    dispatch({ type: "CLOSE_LOAD_HOME" });
  };

  useEffect(() => {
    //setFormatoFecha(getFormatDateLocalStorage());
    if (
      Credenciales.companyId !== "00000000-0000-0000-0000-000000000000" &&
      Credenciales.userId !== "00000000-0000-0000-0000-000000000000"
    ) {
      LoadClientsContactProperties();
    } else {
      SetListTiposTelefonos([]);
      SetListTiposCorreos([]);
      SetListTiposDirecciones([]);
    }
  }, [Credenciales.companyId, Credenciales.userId]);

  const setUltimaAdmisionPendiente = (admision) => {
    setAdmisionEstudiante(admision);
    setEstadoRegistro(admision === "00000000-0000-0000-0000-000000000000");
  };

  const [campos, setCampos] = useState([
    {
      sectionId: "",
      sectionName: "",
      fieldList: [
        {
          fieldId: "",
          sectionId: "",
          typeField: "",
          fieldDescrp: "",
          isRequired: false,
          dataField: "",
          displayOrder: "",
          pattern: "",
          maxlength: "",
          minimum: "",
          maximum: "",
          minDate: "",
          maxDate: "",
          decimal: "",
          value: "",
          fieldName: "",
          listRecords: "",
        },
      ],
    },
  ]);

  const llenarContextApp = () => {
    if (Credenciales.customerId !== "00000000-0000-0000-0000-000000000000") {
      dispatch({
        type: "INICIAR_SESION",
        sesion: Credenciales,
        autenticado: true,
      });

      return true;
    }

    return false;
  };

  useEffect(() => {
    const resp = llenarContextApp();

    if (resp) {
      setTimeout(() => {
        ObtenerCampos(Credenciales.customerId);
      }, 1200);
    }
  }, [Credenciales.customerId]);

  const ObtenerCampos = async (customerId = "") => {
    const Params = {
      companyId: Credenciales.companyId,
      portal: "N",
      idRel: customerId,
    };

    const response = await listadoCamposDinamicosPortal(Params);

    if (response.status === 200) {
      //si la respuesta fue existosa
      response.data.map((seccion) =>
        seccion.fieldList.map(function (dato) {
          dato.DataField =
            dato.typeField === "CHECK"
              ? dato.dataField === "0"
                ? "false"
                : "true"
              : dato.typeField;
          return dato;
        })
      );

      setCampos(response?.data);
      // ExistenCamposDinamicos = response?.data.length > 0 ? true : false;
    } else {
      if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }
      setCampos([]);
      // ExistenCamposDinamicos = false;
    }
  };

  const salvarCamposDinamicos = async () => {
    if (campos.length === 0 || camposDinamicosCRUD === false) return true;

    const CamposObligatoriosVacios = [];

    campos.map((seccion) =>
      seccion.fieldList.map((campo) => {
        if (
          campo.isRequired === true &&
          (campo.dataField === "" ||
            campo.dataField === "00000000-0000-0000-0000-000000000000")
        )
          CamposObligatoriosVacios.push(campo);
      })
    );

    if (CamposObligatoriosVacios.length > 0) {
      MostrarMensaje(dispatch, "warning", ["ErrorRequiredFields"]);
      return false;
    }

    const objetoCampoDinamico = {
      companyId: Credenciales.companyId,
      userId: Credenciales.userId,
      idRel: Credenciales.customerId,
      portal: "N",
      FieldList: [],
    };

    campos.map((seccion) =>
      seccion.fieldList.map((campo) => {
        const campA = {
          FieldId: campo.fieldId,
          FieldName: campo.fieldName,
          DataField: campo.dataField,
        };

        objetoCampoDinamico.FieldList.push(campA);
      })
    );

    const response = await gestionCamposDinamicosPortal(objetoCampoDinamico);

    if (response.status === 200) {
      //MostrarMensaje(dispatch, 'success', ["updateOk"]);
      return true;
    } else {
      if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }

      return false;
    }
  };

  return (
    <>
      <TitleComponent
        fontSize={26}
        textTitle={etiquetas.Home.Et_lblRegistro} />

        <Box sx={{display:'flex',  marginTop:'10px', justifyContent:'center'}}>
          <LogoClassLimitless height={30}/>
        </Box>

        <StepperMobile EstadoRegistro={estadoRegistro} />
        
        {estadoRegistro ? (
                <Registro
                  deviceIs={"MOBILE"}
                  campos={campos}
                  SetCamposDinamicosCRUD={setCamposDinamicosCRUD}
                  DatosPresonalesInfo={{
                    CodigoVerificado: {
                      Info: codigoVerificado,
                      SetInfo: setCodigoVerificado,
                    },
                    ActivadorBotones: {
                      Info: activarBotones,
                      SetInfo: setActivarBotones,
                    },
                    TipoCif: idTipoCif,
                    ListIdentificadores: listIdentificadores,
                    ListGeneros: listGeneros,
                    ListEstadosCivil: listEstadosCivil,
                    ListCampReq: {
                      Info: listCamposRequeridos,
                      SetInfo: setListCamposRequeridos,
                    },
                    Cliente: { Info: Cliente, SetInfo: setCliente },
                    Credenciales: {
                      Info: Credenciales,
                      SetInfo: setCredenciales,
                    }
                  }}
                  DatosContactoInfo={{
                    ListTiposTelefonos: ListTiposTelefonos,
                    ListTiposCorreos: ListTiposCorreos,
                    ListTiposDirecciones: ListTiposDirecciones,
                    TipoTelefono: {
                      Info: TipoTelefono,
                      SetInfo: SetTipoTelefono,
                    },
                    TipoCorreo: { Info: TipoCorreo, SetInfo: SetTipoCorreo },
                    TipoDireccione: {
                      Info: TipoDireccion,
                      SetInfo: SetTipoDireccion,
                    },
                  }}
                  DatosNacionalidadInfo={{
                    ListPaises: listPaises,
                    Pais: { Info: PaisCIF, SetInfo: SetPaisCIF },
                  }}
                  SetUltimaAdmisionPendiente={setUltimaAdmisionPendiente}
                  SetAdmisionPreExistente={setAdmisionPreExistente}
                />
              ) : (
                <Admision
                  deviceIs={"MOBILE"}
                  Credenciales={Credenciales}
                  AdmisionEstudiante={admisionEstudiante}
                  SetAdmisionEstudiante={setAdmisionEstudiante}
                  SetRequisitosPendientes={setRequisitosPendientes}
                  SetAdmisionPreExistente={setAdmisionPreExistente}
                  AdmisionPreExistente={admisionPreExistente}
                />
              )}
              <HomeFooter
                deviceIs={"MOBILE"}
                Credenciales={Credenciales}
                SetCredenciales={setCredenciales}
                guardarCamposDinamicosProp={salvarCamposDinamicos}
                EstadoRegistro={estadoRegistro}
                SetEstadoRegistro={setEstadoRegistro}
                CodigoVerificado={
                  codigoVerificado === true &&
                  activarBotones === true &&
                  Credenciales.customerId !==
                    "00000000-0000-0000-0000-000000000000"
                }
                CustomerId={Credenciales.customerId}
                AdmisionEstudiante={admisionEstudiante}
                RequisitosPendientes={requisitosPendientes}
                AdmisionPreExistente={admisionPreExistente}
                SetRequisitosPendientes={setRequisitosPendientes}
                SetAdmisionEstudiante={setAdmisionEstudiante}
                SetAdmisionPreExistente={setAdmisionPreExistente}
              />


    </>
  )
}
